import { render, staticRenderFns } from "./DistributorVipIndex.vue?vue&type=template&id=87bf3c90"
import script from "./DistributorVipIndex.vue?vue&type=script&lang=js"
export * from "./DistributorVipIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports